export const LEAD_MANAGEMENT_REPORT_BTN_FILTERS = [
  { id: "introduction_btn", name: "Introduction", navigateTo: "/lead_management_report/introduction" },
  { id: "high_level_btn", name: "High Level", navigateTo: "/lead_management_report/high_level" },
  { id: "detail_level_one_btn", name: "Detail Level 1", navigateTo: "/lead_management_report/detail_level_one" },
  { id: "detail_level_two_btn", name: "Detail Level 2", navigateTo: "/lead_management_report/detail_level_two" },
];
